export enum TrackingConsent {
    Advertising = 'advertising',
    Functional = 'functional',
    Necessary = 'necessary',
    Performance = 'performance',
}
